module.exports = __webpack_public_path__ + "static/media/nimbus-bg.0f9e44a7.png";